import React, { FC } from 'react';

import { AppLayoutBreakpoint, LegacyPageLayoutBreakpoint, useContainerWidth } from '../../../../util/responsiveness';

import { useClassName } from './HeroBackground.styles';
import { HeroBackgroundProps } from './HeroBackground.types';

const HeroBackground: FC<HeroBackgroundProps> = ({ children, hasBackground, isNewNavRedesign = false }) => {
  const containerWidth = useContainerWidth();
  const shouldShowAtCurrentBreakpoint = containerWidth >= AppLayoutBreakpoint.Width812;
  const isWide = containerWidth > LegacyPageLayoutBreakpoint.Width1044;
  const className = useClassName({
    hasBackground,
    isWide,
    shouldShowAtCurrentBreakpoint,
    isNewNavRedesign,
  });

  return <div className={className}>{children}</div>;
};

export default HeroBackground;
